import axios from "axios";
import React, { useEffect, useState } from "react";
import GetCSFR from "../../../hooks/userAuthentication/GetCSFR";
import LoadingAnimation from "../LoadingAnimation";

type Club = {
    id: number;
    name: string;
};

export default function ClubManagementTool() {
    const [clubs, setClubs] = useState<Club[]>([])
    const csrfToken = GetCSFR({ name: "csrftoken" })
    const [submitting, setSubmitting] = useState<boolean>(false)

    const [newClub, setNewClub] = useState({
        name: "",
        sport: "",
        location: "",
        rate: ""
    });

    const [newMember, setNewMember] = useState({
        clubId: "",
        role: "Admin",
        email: ""
    });

    useEffect(() => {
        fetchClubs()
    }, [])

    function fetchClubs() {
        axios.get(`${process.env.REACT_APP_SKILLJA_URL}/administration/club/get_clubs/`, {
                headers: {
                    "X-CSRFToken": csrfToken,
                    "Content-Type": "application/json"
                },
                withCredentials: true
            })
            .then(res => {
                if (res.status === 200) {
                    setClubs(res.data.clubs);
                }
            })
            .catch(() => alert("Unable to retrieve club list"));
    }

    function createClub(e: React.FormEvent) {
        e.preventDefault()
        setSubmitting(true)
        console.log('1')
        axios.post(`${process.env.REACT_APP_SKILLJA_URL}/administration/club/create_club/`, newClub,
            {
                headers: {
                    "X-CSRFToken": csrfToken,
                    "Content-Type": "application/json"
                },
                withCredentials: true
            })
            .then(res => {
                if (res.status === 201) {
                    fetchClubs()
                }
            })
            .catch(() => alert("Unable to create club"))
            .finally(()=>setSubmitting(false))
    }

    function addClubMember(e: React.FormEvent) {
        e.preventDefault()
        setSubmitting(true)

        axios.post(`${process.env.REACT_APP_SKILLJA_URL}/administration/club/add_club_member/`, newMember,
            {
                headers: {
                    "X-CSRFToken": csrfToken,
                    "Content-Type": "application/json"
                },
                withCredentials: true
            })
            .then(() => setNewMember({clubId: "", role: "Admin", email: ""}))
            .catch(() => alert("Unable to add member"))
            .finally(()=>setSubmitting(false))
    }

    return (
        <div className="border-t-4 border-main-grey-200 w-full">
            <h2 className="font-medium text-xl my-6">Club Management Tool</h2>

            <div className="flex flex-wrap gap-6">
                {/* Add Club */}
                <div className="rounded-xl border w-72 border-main-grey-100 p-3 bg-white">
                    <p className="font-semibold mb-4">Add a club</p>

                    {submitting ?
                        <LoadingAnimation />
                    :
                        <form onSubmit={createClub} className="space-y-2">
                            <input
                                className="form-input px-4"
                                placeholder="Club name"
                                value={newClub.name}
                                onChange={e =>
                                    setNewClub({ ...newClub, name: e.target.value })
                                }
                                required
                            />
                            <input
                                className="form-input px-4"
                                placeholder="Sport"
                                value={newClub.sport}
                                onChange={e =>
                                    setNewClub({ ...newClub, sport: e.target.value })
                                }
                                required
                            />
                            <input
                                className="form-input px-4"
                                placeholder="Location"
                                value={newClub.location}
                                onChange={e =>
                                    setNewClub({
                                        ...newClub,
                                        location: e.target.value
                                    })
                                }
                                required
                            />
                            <input
                                className="form-input px-4"
                                placeholder="Custom Rate Fee (%)"
                                value={newClub.rate}
                                onChange={e =>
                                    setNewClub({ ...newClub, rate: e.target.value })
                                }
                                required
                            />

                            <button className="form-btn w-full py-2 mt-4">
                                Create Club
                            </button>
                        </form>
                    }
                </div>

                {/* Add Member */}
                <div className="rounded-xl border w-72 border-main-grey-100 p-3 bg-white">
                    <p className="font-semibold mb-4">Add Club Member</p>
                    {submitting ?
                        <LoadingAnimation />
                    :
                    
                        <form onSubmit={addClubMember} className="space-y-2">
                            <input
                                className="form-input px-4"
                                placeholder="Club ID"
                                value={newMember.clubId}
                                onChange={e =>
                                    setNewMember({
                                        ...newMember,
                                        clubId: e.target.value
                                    })
                                }
                                required
                            />
                            <select
                                className="form-input px-4"
                                value={newMember.role}
                                onChange={e =>
                                    setNewMember({
                                        ...newMember,
                                        role: e.target.value
                                    })
                                }
                            >
                                <option>Admin</option>
                                <option>Coach</option>
                            </select>
                            <input
                                className="form-input px-4"
                                placeholder="Account email"
                                value={newMember.email}
                                onChange={e =>
                                    setNewMember({
                                        ...newMember,
                                        email: e.target.value
                                    })
                                }
                                required
                            />

                            <button className="form-btn w-full py-2 mt-4">
                                Add Member
                            </button>
                        </form>
                    }
                </div>

                {/* Club List */}
                <div className="rounded-xl border w-72 border-main-grey-100 p-3 bg-white">
                    <p className="font-semibold mb-4">Available Clubs</p>

                    {!clubs && (
                        <p className="text-sm text-main-grey-400">
                            No clubs found
                        </p>
                    )}

                    {clubs && clubs.map(club => (
                        <div key={club.id} className="p-2 border-b last:border-0">
                            {club.name} (ID: {club.id})
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}